module.exports = __webpack_public_path__ + "img/Entia-Carreteras-y-edificaciones-4.15beba28.webp";